import { gql } from '@apollo/client'

const updateImDfmFeedbackInfoMutation = gql`
    mutation updateImDfmFeedbackInfo(
        $dfmFeedbackId: UUID!
        $topicId: String
        $status: String
        $title: String
    ) {
        updateDfmFeedbackInfo(
            dfmFeedbackId: $dfmFeedbackId
            topicId: $topicId
            status: $status
            title: $title
        ) {
            id
            status
            topic {
                id
                label
            }
            title
            updatedAt
            updatedBy {
                id
                email
            }
        }
    }
`

export default updateImDfmFeedbackInfoMutation

// This is the refetchQuery paired with the above mutation
// in order to get the updated ordered DFM list after an update
export const updateImDfmFeedbackRefetchQuery = gql`
    query imDfmFeedbackUpdateRefetchQuery($id: UUID!) {
        quoteModelRevision(id: $id) {
            dfmFeedback(includeDraft: true) {
                id
            }
        }
    }
`
